module.exports = __webpack_public_path__ + "assets/img/DS-kitchen (7).78c6f8cd.jpg";